import { Box } from '@mui/material';
import React from 'react';
import { theme } from '../../../../../../common/styles/theme';

interface ICallTimer {
	startedAt: number;
}

export const formatElapsed = (ms: number) => {
	const total = Math.max(0, Math.floor(ms / 1000));
	const h = Math.floor(total / 3600);
	const m = Math.floor(total / 60) % 60;
	const s = total % 60;
	const pad = (n: number) => `0${n}`.slice(-2);
	return h ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

// Elapsed since the call itself started (not since this participant joined).
export const CallTimer = ({ startedAt }: ICallTimer) => {
	const [now, setNow] = React.useState(Date.now());

	React.useEffect(() => {
		const id = setInterval(() => setNow(Date.now()), 1000);
		return () => clearInterval(id);
	}, []);

	return (
		<Box
			sx={{
				width: 'auto',
				mt: .5,
				p: .25,
				fontVariantNumeric: 'tabular-nums',
				background: theme.palette.grey[50],
				borderRadius: theme.spacing(.5),
			}}
		>
			{formatElapsed(now - startedAt)}
		</Box>
	);
};
